module.exports = __webpack_public_path__ + "img/seleccionarAyuda.fc327779.png";